// contact.service.ts
import { Injectable } from '@angular/core';
import { GetContactsGQL, Contact, ContactFilterInput, ContactSortInput } from '../../generated/eveportal-api/graphql';
import { map, Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { PresenceState } from '../enums/presence-state.enum';


@Injectable({providedIn: 'root'})
export class ContactService {

  constructor(private getContactsGQL: GetContactsGQL, private http: HttpClient) {}

  getContacts(filter: ContactFilterInput,  skip = 0, take = 10): Observable<ContactQueryResult> {
    return this.getContactsGQL.fetch({ filter, skip, take }, {fetchPolicy: 'network-only'}).pipe(
      map((result: any) => {
        return {
          items: result.data.contacts.items,
          totalCount: result.data.contacts.totalCount
        };
      })
    );
  }

  getAvatar = (eveUserName: string): Observable<Blob> => {
    const avatarUrl = `${environment.config.system.evePortalApiUrl}/EveUser/${eveUserName}/Avatar`;
    return this.http.get(avatarUrl, { responseType: 'blob' });
  }
}


export interface ContactQueryResult {
  items: Contact[];
  totalCount: number;
}

export interface ExtendedContact extends Contact {
  avatarUrl: string;
  presenceState?: PresenceState; // e.g., "Available", "Busy", "Offline"
}
